import { IConversationConfiguration, IPersonalGptConfiguration, ISpeechToTextConfiguration, ISyensqoRagGptsConfiguration } from "../../EnterpriseGPTApi/EnterpriseGPTApiV1Client";

export type FeatureName = keyof FeatureFlags;

export type FeatureFlags = {
    chat: ChatFeature;
};

export const defaultFeatureFlagsState: FeatureFlags = {
    chat: {
        conversation: {
            maxMessageLength: 0,
            maxConversationLength: 0,
            isChainOfThoughtsEnabled: false,
            isUploadSurvey: false
        },
        personalGpt: {
            isEnabled: false
        },
        speechToText: {
            isEnabled: false,
            region: undefined,
            languages: []
        }

    }
};

// Add here new chat features mapping them with the ones from the API 
export interface ChatFeature {
    conversation?: IConversationConfiguration;
    personalGpt?: IPersonalGptConfiguration;
    syensqoRagGPT?: ISyensqoRagGptsConfiguration;
    speechToText?: ISpeechToTextConfiguration;
    isAdmin?: boolean; // Indicates if the user is an admin
    modelKnowledgeCutoffs?: Record<string, string>; // Map model name to cutoff date
}